import { useEffect } from "react";

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

export function Seo({ title, description, lang, noindex }) {
  useEffect(() => {
    document.title = title;
    if (lang) document.documentElement.lang = lang;
    if (description) {
      setMeta("name", "description", description);
      setMeta("property", "og:title", title);
      setMeta("property", "og:description", description);
    }
    setMeta("name", "robots", noindex ? "noindex" : "index, follow");
  }, [title, description, lang, noindex]);
  return null;
}
